export const theme = {
  bg: "#FAF8F4",
  bgLight: "#F0EDE7",
  primary: "#FF5722",
  text_primary: "#111111",
  text_secondary: "#666666",
  card: "#FFFFFF",
  cardBorder: "#E4E0D8",
  white: "#FFFFFF",
  black: "#111111",
};

export const lightTheme = theme;
export const darkTheme = theme;
